import TermsOfUsePage from 'features/terms-of-use'

export const termsOfUseRoutes = [
  {
    path: '/terms-of-use',
    element: <TermsOfUsePage />
  }
]
